class StickyElement extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.ele = this.parentElement;
    this.currentScrollTop = 0;
    this.onScrollHandler = this.onScroll.bind(this);
    this.eleBounds = {};


    this.offsetVariable = this.getAttribute('data-offset-variable') || '';

    this.ele.style = `--sticky-offset: var(${this.offsetVariable})`;

    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
    this.createObserver();
    window.addEventListener('scroll', this.onScrollHandler, false);

    if (this.headerIsAlwaysSticky) {
      this.reveal();
    }
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
      this.eleBounds = entries[0].intersectionRect;
      observer.disconnect();
		});

		if (this.ele) {
			observer.observe(this.ele);
		}
	}


  onScroll() {

	  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > this.currentScrollTop && scrollTop > this.eleBounds.bottom) {
      // 向下滚动并且滚动超出元素时 隐藏
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.eleBounds.bottom) {
      // 向上滚动并且依旧在超出元素的视窗 显示
      requestAnimationFrame(this.reveal.bind(this));
    } else if (scrollTop <= this.eleBounds.top) {
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;

  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
		this.ele.classList.add('sticky-element__hidden');
	}

	reveal() {
		this.ele.classList.add('sticky-element', 'animate');
		this.ele.classList.remove('sticky-element__hidden');
	}

  reset() {
    if (this.headerIsAlwaysSticky) return;
		this.ele.classList.remove('sticky-element', 'sticky-element__hidden', 'animate');
  }

}

customElements.define('sticky-element', StickyElement);